import { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, HelpCircle, Headset } from "lucide-react";
import { waList, igList, waNum, waLink, imgSrc } from "@/lib/api";
import WaIcon from "@/components/WaIcon";

export default function FloatingContact({ site }) {
  const [menu, setMenu] = useState(""); // "" | "wa" | "ig"
  const was = waList(site);
  const igs = igList(site);

  const toggle = (m) => setMenu(menu === m ? "" : m);
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3" data-testid="floating-contact">
        {menu === "wa" && (
          <div className="wa-brand-shell w-[min(21rem,calc(100vw-2.5rem))] overflow-hidden rounded-2xl" data-testid="float-wa-menu">
            <p className="wa-brand-header px-5 py-4 text-sm font-semibold leading-relaxed">Halo Kak, silakan pilih admin yang dapat membantu.</p>
            <div className="space-y-1 p-3">
              {was.map((w, i) => (
                <a key={i} href={waLink("Halo Admin NAWADAH, saya ingin bertanya.", waNum(w.number))} target="_blank" rel="noreferrer" onClick={() => setMenu("")} data-testid={`float-wa-item-${i}`} className="wa-brand-row group flex w-full items-center gap-3 rounded-xl border border-transparent p-3 text-left transition-colors">
                  <span className="wa-brand-avatar relative flex h-14 w-14 shrink-0 items-center justify-center rounded-full">
                    {w.image ? <img src={imgSrc(w.image)} alt={w.label || `Admin Nawadah ${i + 1}`} className="h-full w-full rounded-full object-cover" /> : <Headset className="h-7 w-7" />}
                    <span className="wa-brand-badge absolute -bottom-1 -right-1 rounded-full p-1 shadow"><WaIcon className="h-4 w-4" /></span>
                  </span>
                  <span className="min-w-0">
                    <span className="wa-brand-eyebrow block text-[10px] font-bold uppercase tracking-wider">Admin Account</span>
                    <span className="wa-brand-name block truncate text-base font-extrabold">{w.label || `NDH-Admin ${i + 1}`}</span>
                  </span>
                </a>
              ))}
            </div>
            <p className="wa-brand-footer px-4 py-3 text-center text-xs font-extrabold">NAWADAH <span>by NDH Official</span></p>
          </div>
        )}
        {menu === "ig" && (
          <div className="bg-white text-slate-900 rounded-md border border-slate-200 shadow-xl p-2 w-64" data-testid="float-ig-menu">
            <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400 px-3 py-2">Instagram Kami</p>
            {igs.map((g, i) => (
              <a key={i} href={`https://instagram.com/${String(g.handle).replace(/^@/, "")}`} target="_blank" rel="noreferrer" data-testid={`float-ig-item-${i}`} className="block px-3 py-2.5 rounded-md hover:bg-slate-100 transition-colors">
                <p className="text-sm font-bold">{g.label || "Instagram"}</p>
                <p className="text-xs text-slate-500">{g.handle}</p>
              </a>
            ))}
          </div>
        )}
        <Link
          to="/faq"
          data-testid="float-faq"
          title="Tanya Jawab (FAQ) seputar bisnis & produk"
          className="h-12 w-12 rounded-full bg-white text-[#0B1F3A] border border-slate-200 shadow-lg flex items-center justify-center hover:scale-105 transition-transform"
        >
          <HelpCircle className="h-5 w-5" />
        </Link>
        {igs.length > 1 ? (
          <button
            onClick={() => toggle("ig")}
            data-testid="float-ig"
            title="Instagram"
            className="h-12 w-12 rounded-full bg-white text-[#0B1F3A] border border-slate-200 shadow-lg flex items-center justify-center hover:scale-105 transition-transform"
          >
            <Instagram className="h-5 w-5" />
          </button>
        ) : (
          <a
            href={`https://instagram.com/${String(igs[0].handle).replace(/^@/, "")}`}
            target="_blank"
            rel="noreferrer"
            data-testid="float-ig"
            title="Instagram"
            className="h-12 w-12 rounded-full bg-white text-[#0B1F3A] border border-slate-200 shadow-lg flex items-center justify-center hover:scale-105 transition-transform"
          >
            <Instagram className="h-5 w-5" />
          </a>
        )}
        {was.length > 1 ? (
          <button onClick={() => toggle("wa")} data-testid="float-wa" title="Chat WhatsApp" className="wa-brand-trigger h-14 w-14 rounded-full shadow-xl flex items-center justify-center transition-transform">
            <WaIcon className="h-7 w-7" />
          </button>
        ) : (
          <a href={waLink("Halo Admin NAWADAH, saya ingin bertanya.", waNum(was[0].number))} target="_blank" rel="noreferrer" data-testid="float-wa" title="Chat WhatsApp" className="wa-brand-trigger h-14 w-14 rounded-full shadow-xl flex items-center justify-center transition-transform">
            <WaIcon className="h-7 w-7" />
          </a>
        )}
      </div>
  );
}
